<template>
	<div>
		<list-page-gen :options="options" />
	</div>
</template>

<script>
import ListPageGen from './ListPageGen.vue'

const config = {
	options: {
		resource: 'alert-subscriptions',
		display: [
			{ key: 'id' },
			{ key: 'alertTypeId' },
			{ key: 'userGroup' },
			{ key: 'createdAt' }
		],
		syncEnabled: false,
		modifier: async data =>
			data.map(r => {
				r.userGroup = r.userGroup.name
				return r
			}),
		canEdit: false
	}
}

export default {
	name: 'AlertSubscriptionsList',
	components: { ListPageGen },
	data: () => config
}
</script>
